import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import { sampleBoard } from "../BoardSample/sample";
import { castWorldBoundsFromBoard } from "../BoardSample/castBounds";
import type { FitCastBoardContext } from "./context";
import type { CastBounds } from "./locations";
import { castWorldBounds } from "./view";

/** Fit-cast bounds for the camera only; never drives location label visibility. */
export function resolveCastWorldBounds(
  layout: BookTimelineLayout,
  viewportWidth: number,
  playheadMs: number,
  boardContext?: FitCastBoardContext | null,
): CastBounds | null {
  if (boardContext !== undefined && boardContext !== null) {
    const sample = boardContext.sample.playheadMs === playheadMs
      ? boardContext.sample
      : sampleBoard(boardContext.board, playheadMs);
    return castWorldBoundsFromBoard(
      sample,
      boardContext.board,
      viewportWidth,
      playheadMs,
    );
  }
  return castWorldBounds(layout, viewportWidth, playheadMs);
}
